import "./ChatComponent.css";

const ChatComponent: React.FC<{
  id?: string;
  type?: any;
  name?: any;
  image?: any;
  timestamp?: any;
  message?: any;
}> = ({ id, type, name, image, timestamp, message }) => {
  return (
    <>
      <div className="text-center text chat-time mt-3 mb-2">{timestamp}</div>
      {type === "receiving" ? (
        <>
          <div className="d-flex mb-2 sender align-items-start">
            <div className="text-center chat-img col-2 my-auto mb-0">
              <figure className="m-0 pe-0">
                {image ? (
                  <img
                    src={image}
                    alt={name}
                    className="img-fluid chat-image"
                  />
                ) : (
                  <div
                    style={{ borderRadius: "4px 4px 0px 0px" }}
                    className="default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image"
                  >
                    <i className="fa-solid fa-user" style={{fontSize:20}}></i>
                  </div>
                )}
              </figure>
              <div className="text mx-auto w-75 name mt-1">{name}</div>
            </div>
            <div
              className={`bubble bubble-left col-8 chat-msg ${
                name.length > 15 ? "mb-md-5" : "mb-md-4"
              }`}
              id={`msg-${id}`}
            >
              <div className="p-3 d-block mh-75 text-black content">
                {message}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="d-flex mb-2 receiver justify-content-end align-items-start">
            <div
              className={`bubble bubble-right col-8 chat-msg ${
                name.length > 15 ? "mb-md-5" : "mb-md-4"
              }`}
              id={`msg-${id}`}
            >
              <div className="p-3 d-block mh-75 text-black content">
                {message}
              </div>
            </div>
            <div className="text-center chat-img col-2 my-auto mb-0">
              <figure className="m-0 pe-0">
                {image ? (
                  <img
                    src={image}
                    alt={name}
                    className="img-fluid chat-image"
                  />
                ) : (
                  <div
                    style={{ borderRadius: "4px 4px 0px 0px" }}
                    className="default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image"
                  >
                    <i className="fa-solid fa-user" style={{fontSize:20}}></i>
                  </div>
                )}
              </figure>
              <div
                className="text mx-auto w-100 mt-1"
                style={{ wordBreak: "break-word", whiteSpace: "normal" }}
              >
                {name}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ChatComponent;
